import { render } from "./index.vue?vue&type=template&id=8966b7d6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/modals/ModalUpsell/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8966b7d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8966b7d6', __exports__)) {
    api.reload('8966b7d6', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=8966b7d6", () => {
    api.rerender('8966b7d6', render)
  })

}


export default __exports__